export default "__VITE_ASSET__DCxvr2te__"